// removed by extract-text-webpack-plugin
module.exports = {"my-setting-wrapper":"index__my-setting-wrapper___1jUGP","avatar-wrapper":"index__avatar-wrapper___25nlP","changepwd-wrapper":"index__changepwd-wrapper___2jjpd","avatar-img-wrapper":"index__avatar-img-wrapper___3TymD","avatar-img":"index__avatar-img___WzNre","total-weight":"index__total-weight___3BReN"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Task/index.less
// module id = 1631
// module chunks = 3